import { FC } from 'react';
import { TutorialCard } from '../TutorialCard/TutorialCard';
import { type NewlaneTutorial } from '@teachur/http-client';

interface TutorialGridProps {
  tutorials: NewlaneTutorial[];
  searchQuery?: string;
}

export const TutorialGrid: FC<TutorialGridProps> = ({ tutorials, searchQuery }) => {
  if (tutorials.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-(--neutral-black-NB600) [font-size:var(--fs-p3)]!">
          {searchQuery ? 'No tutorials found matching your search.' : 'No tutorials available.'}
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
      {tutorials.map((tutorial) => (
        <TutorialCard key={tutorial.id} tutorial={tutorial} />
      ))}
    </div>
  );
};
